<iframe width="100%" height="100%" style="border: 0px;" *ngIf="pdfDocumentView" [src]="pdfDocumentView" type="application/doc"></iframe>
